module.exports = __webpack_public_path__ + "static/img/5.64ea8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/5.png
// module id = ektc
// module chunks = 0